// extracted by mini-css-extract-plugin
module.exports = {"Loader-wrapper":"loader_Loader-wrapper__3JI3y","loader":"loader_loader__2mgM5","Table":"loader_Table__2kZWo"};